var map = {
	"./ar/posts/index.vue": [
		1118,
		8568,
		1118
	],
	"./bn/posts/index.vue": [
		5079,
		8568,
		5079
	],
	"./en/posts/index.vue": [
		6012,
		8568,
		6012
	],
	"./fa/posts/index.vue": [
		4711,
		8568,
		4711
	],
	"./ur/posts/index.vue": [
		947,
		8568,
		947
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 4152;
module.exports = webpackAsyncContext;